// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SolidGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { get } from 'lodash/fp';

export default H => {

  const wrap = H.wrap;
  /** OVERRIDE HIGHMAP ColorAxis FUNCTION **/
  wrap(H.ColorAxis.prototype, 'normalizedValue', function (_proceed, value, customMin, customMax) {
    var actualMax = !isNaN(customMax) && customMax !== null ? customMax : this.max;
    var actualMin = !isNaN(customMin) && customMin !== null ? customMin : this.min;
    if (actualMin === actualMax) {
      return actualMin < value ? 0 : 1;
    }
    if (this.isLog) {
      value = this.val2lin(value);
    }
    return 1 - ((actualMax - value) / ((actualMax - actualMin) || 1));
  });
  wrap(H.ColorAxis.prototype, 'toColor', function (_proceed, value, point) {
    var pos,
      stops = this.stops,
      from,
      to,
      color,
      dataClasses = this.dataClasses,
      dataClass,
      i;
    
    const rangesObject = get('rangesObject', point);
    if (!rangesObject) {
      return null;
    }

    var range = rangesObject.range;
    var minFieldValue = undefined;
    var maxFieldValue = undefined;
    if (get('type', rangesObject) === 'value') {
      minFieldValue = range[0][0];
      maxFieldValue = range[0][1];
    }

    if (dataClasses) {
      i = dataClasses.length;
      while (i--) {
        dataClass = dataClasses[i];
        from = dataClass.from;
        to = dataClass.to;
        if (
          (from === undefined || value >= from) &&
          (to === undefined || value <= to)
        ) {

          color = dataClass.color;

          if (point) {
            point.dataClass = i;
            point.colorIndex = dataClass.colorIndex;
          }
          break;
        }
      }

    } else {
      if (minFieldValue < maxFieldValue)
        pos = this.normalizedValue(value, minFieldValue, maxFieldValue);
      else
        pos = 1 - this.normalizedValue(value, maxFieldValue, minFieldValue);
      i = stops.length;
      while (i--) {
        if (pos > stops[i][0]) {
          break;
        }
      }
      from = stops[i] || stops[i + 1];
      to = stops[i + 1] || from;

      // The position within the gradient
      pos = 1 - (to[0] - pos) / ((to[0] - from[0]) || 1);

      color = from.color.tweenTo(
        to.color,
        pos
      );
    }
    return color;
  });
};



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.ColorAxis.js